export default __webpack_public_path__ + "static/media/Img333.d3a05b6d.jpg";